<!-- 学术沙龙会 -->
<template>
    <div>
       <sub-banner id="id_about">
        <img src="../../assets/images/video/video_banner.jpg"/>
      </sub-banner>
      <!-- 学术会议轮播列表 -->
    <div class="academic-list">
        <div 
          v-for="(item, index) in groupedItemList" 
          :key="index"
          class="academic-item"
          :class="{ 'culture_info_back': index % 2 === 0 }"
        >
          <div class="academic-header">
            <h3 class="title_s">{{ item.title }}</h3>
          </div>
          
          <!-- 图片分组轮播 -->
          <el-carousel 
            :interval="5000"
            arrow="always"
            indicator-position="inside"
            class="academic-carousel"
            height="200px"
          >
            <el-carousel-item 
              v-for="(group, groupIndex) in item.groups" 
              :key="groupIndex"
              class="carousel-group"
            >
              <div class="image-group">
                <el-image
                  v-for="(img, imgIndex) in group"
                  :key="imgIndex"
                  :src="img.synopsisImg"
                  :preview-src-list="ItemListPreview"
                  fit="cover"
                  class="group-image"
                >
                  <div slot="error" class="image-error">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
</template>

<script>

import SubBanner from "@/components/sub-banner";
export default {
  name: 'concat',
  metaInfo () {
    return {
      title: this.pageTitle,
      meta:[{
        name:this.metaName,
        content:this.metaContent,
        keyword:this.keyword,
        description:this.description
      }]
    }
  },
  components: {SubBanner},
  data () {
    return {
      pageTitle: '广州市熵达贸易有限公司-学术沙龙会',
      metaName:'广州市熵达贸易有限公司-学术沙龙会',
      metaContent:'广州市熵达贸易有限公司-学术沙龙会',
      keyword:'广州市熵达贸易有限公司,',
      description:'广州市熵达贸易有限公司' ,   
      form: {
        code: '',
        name: '',
        phone: '',
        needContent:'',
      },      
      ItemList:[
        {
            title:'第三届珠江数智化微创肝胆胰外科卓越论坛',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_2.jpg',hidden:false},
                // {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_5.jpg',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_6.jpg',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_7.jpg',hidden:false},
                {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_8.jpg',hidden:false},
                {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_9.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_10.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_11.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_12.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo7_13.jpg',hidden:false},
            ]
        },
        {
            title:'数智化微创肝胆胰手术视频交流会',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_5.jpg',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_6.jpg',hidden:false},
                {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_7.jpg',hidden:false},
                {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_8.jpg',hidden:false},
                {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_9.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_10.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo8_11.jpg',hidden:false},
            ]
        },
        
        {
            title:'数字智能化外科专业委员会学术会议-开幕式 院士及主旨论坛',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_5.jpg',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_6.jpg',hidden:false},
                {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_7.jpg',hidden:false},
                {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_8.jpg',hidden:false},
                {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_9.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_10.jpg',hidden:false},
                {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_11.jpg',hidden:false},
                // {id:10,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo9_12.jpg',hidden:false},
            ]
        },
        
        {
            title:'智领未来-AI外科技术创新与实践论坛',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_4.jpg',hidden:false},
                // {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_5.jpg',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_6.jpg',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_7.jpg',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_8.jpg',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo10_9.jpg',hidden:false},
            ]
        },
        {
            title:'广州市医学会胃肠外科学分会学术年会暨广州胃肠微创外科高峰论坛',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_1.png',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_2.png',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_3.png',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_4.png',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_5.png',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_6.png',hidden:false},
                {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_7.png',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_8.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo2_9.JPG',hidden:false},
            ]
        },
        {
            title:'肝胆相照，共筑健康——广东省健康科普促进会肝胆胰健康管理分会（暨第一届柔济妊娠期肝胆胰疾病诊治学习班）成立大会',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_4.jpg',hidden:false},
                // {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_5.JPG',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_6.JPG',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_7.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_8.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_9.JPG',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_10.JPG',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_11.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_12.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_13.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_14.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo3_15.JPG',hidden:false},
            ]
        },
        {
            title:'2024尿路修复学术论坛',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_5.jpg',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_6.jpg',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_7.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_8.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo4_9.JPG',hidden:false},
            ]
        },
        {
            title:'2021.12.3珠江医妇科会议学习',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_5.jpg',hidden:false},
                {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_6.jpg',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_7.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_8.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_9.JPG',hidden:false},
                // {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_10.JPG',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_11.JPG',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_12.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_13.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_14.JPG',hidden:false},
                // {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_15.JPG',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_16.JPG',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_17.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_18.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_19.JPG',hidden:false},
                // {id:7,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_20.JPG',hidden:false},
                // {id:8,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_21.JPG',hidden:false},
                // {id:9,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo5_22.JPG',hidden:false},
            ]
        },
        {
            title:'2020.8.7单孔腹腔镜在妇科的应用沙龙会（广州站）',
            image:[
                {id:0,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_1.jpg',hidden:false},
                {id:1,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_2.jpg',hidden:false},
                {id:2,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_3.jpg',hidden:false},
                {id:4,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_4.jpg',hidden:false},
                {id:5,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_5.jpg',hidden:false},
                // {id:6,synopsisImg:process.env.BASE_IMG_URL+'/attachments/upload/image/salo6_6.JPG',hidden:false},
            ]
        },
      ],
      
      ItemListPreview:[
      ],
    };
  },
  computed: {
     // 分组计算属性
     groupedItemList() {
      const groupSize = 4; // 每组显示4张图片
      const groupsd= this.ItemList.map(item => ({
        ...item,
        groups: this.chunkArray(item.image, groupSize)
      }));
      console.log(groupsd,'groupsd')
      return groupsd
    }
  },
  watch: {
    '$store.state.lang': function (nval, oval) {
      let obj = {
        'en-US': 'Guangzhou entropy Da Trade Co., Ltd',
        'zh-TCC': '廣州市熵達貿易有限公司',
        'zh-CN': '广州市熵达贸易有限公司'
      }
      this.pageTitle = obj[nval]
    }
  },
  mounted(){
    this.getPersonEvnItemListPreview()
    
    // 初始化预览列表
    this.ItemListPreview = this.ItemList.flatMap(item => 
      item.image.map(img => img.synopsisImg)
    );
    // 响应式处理
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    getImage(img){
        console.log(img,'img')
    },
    getPersonEvnItemListPreview(){
        this.ItemListPreview=[]
        this.ItemList.map((v)=>{
            v.image.map(x=>{
                this.ItemListPreview.push(x.synopsisImg)
            })
        })
      },
    leftPersonEnvClick(index){
        let origTeamList=this.ItemList[index].image;
        let objNewTeam=[];
        let first=origTeamList[0];
        for(var i=1;i<origTeamList.length;i++){
            objNewTeam.push(origTeamList[i]);
        }
        objNewTeam.push(first);
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.ItemList[index].image=objNewTeam;
      },
      righPersontEnvClick(index){
        let origTeamList=this.ItemList[index].image;
        let objNewTeam=[];
        let last=origTeamList[origTeamList.length-1];
        objNewTeam.push(last);
        for(var i=0;i<origTeamList.length-1;i++){
            objNewTeam.push(origTeamList[i]);
        }
        
        for(var j=0;j<objNewTeam.length;j++){
            if(j<4){
                objNewTeam[j].hidden=false;
            }else{
                objNewTeam[j].hidden=true;
            }
        }
        this.ItemList[index].image=objNewTeam;
      },
      
    //   getPersonEvnItemListPreview(){
    //     this.ItemListPreview=[]
    //     this.ItemList.map((v)=>{
    //       this.ItemListPreview.push(v.synopsisImg)
    //     })
    //   }
     // 数组分块方法
     chunkArray(arr, size) {
      return Array.from(
        { length: Math.ceil(arr.length / size) },
        (_, i) => arr.slice(i * size, i * size + size)
      );
    },
     // 响应式处理
     handleResize() {
      this.$nextTick(() => {
        // 可添加响应式布局调整逻辑
      });
    }
  },
  
  created () {

  },
}
</script>
<style lang='scss' scoped>


.academic-list {
    width:70%;
    margin: 0 auto;
    padding: 20px;
  }
  
  .academic-item {
    margin-bottom: 40px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    
    &.culture_info_back {
      background: #f8f9fa;
    }
  }
  
  .academic-header {
    padding: 24px;
   // border-bottom: 1px solid #eee;
    
    .title_s {
      
        color: #4f7cbd;
        font-size:40px;
        font-weight: bold;
        cursor: pointer;
    }
  }
  
  .academic-carousel {
    border-radius: 8px;
    overflow: hidden;
    
    ::v-deep .el-carousel__arrow {
      background: rgba(0,122,204,0.8);
      i { color: white; }
      
      &:hover {
        background: #007acc;
      }
    }
    
    ::v-deep .el-carousel__indicator {
      padding: 12px 4px;
      
      .el-carousel__button {
        width: 24px;
        height: 3px;
        border-radius: 2px;
        background: #004d80;
        opacity: 0.6;
      }
      
      &.is-active .el-carousel__button {
        background: #007acc;
        opacity: 1;
      }
    }
  }
  
  .image-group {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    height: 100%;
    box-sizing: border-box;
    
    .group-image {
      flex: 0 0 23%;
      height: 200px;
      border-radius: 4px;
      transition: transform 0.3s;
      
      &:hover {
        transform: translateY(-4px);
      }
    }
  }
  
  .image-error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    background: #f5f7fa;
    color: #909399;
    
    i {
      font-size: 40px;
    }
  }
  
  @media (max-width: 768px) {
    .image-group .group-image {
      flex: 0 0 48%;
      height: 150px;
      margin: 2px;
    }
    
    .academic-carousel {
      height: 180px !important;
    }
  }
</style>
<style>

</style>


// WEBPACK FOOTER //
// src/view/academicTrends/academicMeet.vue